import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../actions'
import Merchandise from './Merchandise'
import axios from 'axios'
import { Container, Button, Icon, Form, FormGroup, FormField, Input, Divider, Message, Image } from 'semantic-ui-react'
import { COLORS } from  '../../../utilities/colours'

const ResellerMLBB = ({ game, backClicked, markup }) => {
    const [userID, setUserID] = useState('')
    const [serverID, setServerID] = useState('')
    const [userName, setUserName] = useState('')
    const [isLoadingVerify, setIsLoadingVerify] = useState(false)
    const [isUserVerified, setIsUserVerified] = useState(false)
    const [showInvalidUserMessage, setShowInvalidUserMessage] = useState(false)
    const [showOutOfStockMessage, setShowOutOfStockMessage] = useState(false)
    const [packageDisplayName, setPackageDisplayName] = useState('')
    const [packageSupplierName, setPackageSupplierName] = useState('')
    const [gameItems, setGameItems] = useState([])
    const [showPurchaseSuccessMessage, setShowPurchaseSuccessMessage] = useState(false)

    const dispatch = useDispatch()
    const user = useSelector(state => state.userReseller)

    const isUserRestrictedFromMLBB = (restrictedMLBBUsers) => {
        if (!Array.isArray(restrictedMLBBUsers)) return false
        for (const restrictedUser of restrictedMLBBUsers) {
            if (restrictedUser.userID === userID && restrictedUser.serverID === serverID) {
                console.log('User is restricted from mlbb package.')
                return true
            }
        }
        return false
    }
    const isPackageOutOfStock = (names, pkgs) => {
        const obj = {}
        if (!Array.isArray(pkgs)) return obj
        for (const pkg of pkgs) {
            if (names.includes(pkg.supplierPackageName)) obj[pkg.supplierPackageName] = pkg.isOutOfStock
        }
        return obj
    }
    const getPackageName = (showWhichPackage, pkgs) => {
        for (const pkg of pkgs) {
            if (pkg.supplierPackageName === showWhichPackage) return pkg.name
        }
    }
    const getGameItems = (showWhichPackage, pkgs) => {
        for (const pkg of pkgs) {
            if (pkg.supplierPackageName === showWhichPackage) return pkg.gameItems
        }
    }
    const getMarkup = () => {
        if (packageSupplierName === 'mlbb') return markup.mlbb
        else if (packageSupplierName === 'mlbb_global') return markup.mlbb_global
        else return markup.mlbb_special
    }
    const getPrice = (cost, discounted, discountRate) => {
        const adjustedMarkup = (discounted && !user.disableDiscounts) ? Number(getMarkup()) - Number(discountRate) : Number(getMarkup())
        return Number(cost) + (adjustedMarkup / 100 * Number(cost))
    }

    // ----- Handler functions ----
    const handleChangeField = e => {
        const { name, value } = e.target
        if (name === 'userID') setUserID(value)
        if (name === 'serverID') setServerID(value)
    }
    const handleVerifyButtonClicked = async () => {
        if (userID === '' || serverID === '') return
        setShowPurchaseSuccessMessage(false)
        setIsLoadingVerify(true)
        try {
            const [gameResponse, restrictedUsersResponse, verifyResponse] = await Promise.all([
                axios.get('/api/resellers/game/' + game._id).catch(err => {
                    alert('Fail update game data, please try again. Error: ' + err)
                    throw err 
                }),
                axios.get('/api/restricted_mlbb_users').catch(err => {
                    alert('Fail to get restricted users, please try again. Error: ' + err)
                    throw err
                }),
                axios.post(process.env.NODE_ENV === 'development' ? '/api/proxy/resellers/verify_id_mlbb' : '/api/resellers/verify_id/mlbb', { userid: userID, serverid: serverID, reseller: user.name }).catch(err => {
                    alert(`Failed to verify ID, please try again. Error: ${err}`)
                    throw err
                })
            ])
            const isRestrictedFromMLBBPackage = isUserRestrictedFromMLBB(restrictedUsersResponse.data)
            const pkgs = gameResponse.data.packages
            const { mlbb_global, mlbb_special, name1, name2, error1, error2, region } = verifyResponse.data
            const mlbb_globalIsValid = mlbb_global === 'valid'
            const mlbb_specialIsValid = mlbb_special === 'valid'
            const outOfStock = isPackageOutOfStock(['mlbb', 'mlbb_special', 'mlbb_global'], pkgs)
            const mlbbOutOfStock = outOfStock.mlbb ?? false
            const mlbbSpecialOutOfStock = outOfStock.mlbb_special ?? false
            const mlbbGlobalOutOfStock = outOfStock.mlbb_global ?? false

            var showWhichPackage = ''
            if (mlbb_globalIsValid && mlbb_special === 'valid' && !mlbbOutOfStock) { // user not from SG, not from Indo. we prioritise showing mlbb package since it's cheaper. so, show mlbb if not out of stock.
                if (region === 'philippines' || isRestrictedFromMLBBPackage) showWhichPackage = 'mlbb_special' // but we can't show mlbb if user is from philippines or myanmar, as they won't be able to top up. we will show them mlbb_special instead.
                else showWhichPackage = 'mlbb'
            } 
            else if (mlbb_globalIsValid && mlbb_specialIsValid && mlbbOutOfStock) showWhichPackage = 'mlbb_special' // if mlbb is out of stock, then no choice, we will show mlbb_special instead
            else if (mlbb_specialIsValid) showWhichPackage = 'mlbb_special'
            else if (mlbb_globalIsValid) showWhichPackage = 'mlbb_global' 
            
            setPackageSupplierName(showWhichPackage)
            setPackageDisplayName(getPackageName(showWhichPackage, pkgs))
            setGameItems(getGameItems(showWhichPackage, pkgs))
            setUserName(mlbb_globalIsValid ? name1 : name2)
            setIsUserVerified((mlbb_globalIsValid || mlbb_specialIsValid))

            // Set error messages: out of stock / invalid user
            if (mlbb_globalIsValid && mlbb_specialIsValid) { // user not from SG, not from Indo. 
                if (mlbbOutOfStock && mlbbSpecialOutOfStock) setShowOutOfStockMessage(true)
            }
            if (mlbb_globalIsValid && mlbbGlobalOutOfStock) setShowOutOfStockMessage(true)
            else if (mlbb_specialIsValid && mlbbSpecialOutOfStock) setShowOutOfStockMessage(true)
            else setShowOutOfStockMessage(false)

            if ((showWhichPackage === 'mlbb_global' && error1) || (showWhichPackage === 'mlbb_special' && error2)) {
                if (error1 === 'Game is under maintenance' || error2 === 'Game is under maintenance') {
                    setShowOutOfStockMessage(true)
                } else {
                    setShowInvalidUserMessage(true)
                }
            } else if (!mlbb_globalIsValid && !mlbb_specialIsValid) {
                setShowInvalidUserMessage(true)
            } else {
                setShowInvalidUserMessage(false)
            }
        } catch (err) {
            console.log('One or more requests failed:', err)
        } finally {
            setIsLoadingVerify(false)
        }
    }
    const handlePurchaseItem = async item => {
        setIsLoadingVerify(true)
        const dict = { reseller: { name: user.name, id: user._id }, game: packageSupplierName, userid: userID, serverid: serverID, denom: item.nameSupplier, userName, itemName: item.nameReseller, 
                        amount: roundUp2DP(getPrice(item.cost, item.isDiscountedReseller, item.discountRateReseller)), cost: item.cost, package: packageDisplayName }
        const url = process.env.NODE_ENV === 'development' ? '/api/proxy/place_order_mlbb' : '/api/reseller/place_order/mlbb'
        await axios.post(url, dict).then(res => {
            dispatch(actions.getCurrentUserReseller())
            setUserID('')
            setServerID('')
            setIsLoadingVerify(false)
            setShowPurchaseSuccessMessage(true)
        }).catch(err => {
            if (err.response) {
                const statusCode = err.response.status
                console.log(`Verify ID failed with status: ${statusCode}, error: ${err.response.data}`)
                if (statusCode === 403) alert('Insufficient balance in your account, please check.')
                else alert(`Failed to place order, please try again. Status: ${statusCode}, Error: ${err.response.data}`)
            } else {
                console.log(`Verify ID failed with error: ${err.message}`)
                alert(`Failed to place order, please try again. Error: ${err.message}`)
            }
            setIsLoadingVerify(false)
        })
    }

    return (
        <Container inverted style={{ background: '#1b1c1d', padding: '20px' }}>
            <Image style={{ marginTop: 30, marginBottom: 50, width: '33%' }} centered src='/mobile-legends.png'/>
            <Form inverted style={{ marginTop: 25 }}>
                <FormGroup widths='equal'>
                    <FormField required control={Input} label={{ children: 'User ID', style: { color: COLORS.PRIMARY_GOLD } }} name='userID' value={userID} placeholder='User ID' onChange={handleChangeField} className="dark-theme-input"/>
                    <FormField required control={Input} label={{ children: 'Server ID', style: { color: COLORS.PRIMARY_GOLD } }} name='serverID' value={serverID} placeholder='Server ID' onChange={handleChangeField} className="dark-theme-input"/>
                </FormGroup>
                {isUserVerified ? <h4 style={{ color: 'white' }}>{userName} ✅</h4> : null}
                <Button loading={isLoadingVerify} style={{ marginTop: 15, backgroundColor: COLORS.PRIMARY_GOLD, color: 'black' }} onClick={handleVerifyButtonClicked}><Icon name='gem'/>Verify</Button>                
            </Form>
            {showOutOfStockMessage ? (
                <Message inverted style={{ marginTop: 30, marginBottom: 30 }} negative header={'Items for ' + packageDisplayName + ' are currently Out of Stock / Under Maintenance.'} content='Please try again later.'/>
            ) : null}
            {showInvalidUserMessage ? (
                <Message inverted style={{ marginTop: 20 }} negative header='Invalid user' content='Please check and try again.'/>
            ) : null}
            {showPurchaseSuccessMessage ? (
                <Message inverted style={{ marginTop: 20 }} success header={'Placed order successfully for User: ' + userName} content='You may track the order status in the Orders page.'/>
            ) : null}
            {isUserVerified && !showOutOfStockMessage ? (
                <div>
                    <Divider inverted style={{ marginTop: 30 }}/>
                    <h4 style={{ color: 'white' }}>Eligible for {packageDisplayName}:</h4>
                    <Merchandise disableDiscounts={user.disableDiscounts} userName={userName} savedDict={{ gameItems: gameItems }} markup={getMarkup()} placeOrder={handlePurchaseItem}/>
                </div>
            ) : null}
            <br/><br/><br/><br/><br/><br/>
            <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: '#2a2b2c', borderTop: '2px solid #444', padding: '10px', zIndex: 100 }}>
                <Container inverted>
                    <Button inverted style={{ marginTop: 8, marginRight: 15, marginBottom: 12 }} onClick={backClicked}><Icon name='reply' />Back</Button>
                </Container>
            </div>
        </Container>
    )
}

const roundUp2DP = num => {
    return Math.ceil(num * 100) / 100
}

export default ResellerMLBB